/// <reference path="../../common/helpers/dialogutils.ts" />
/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsDialog extends _Ext.ItemEditorDialog<StockAllocationItemsRow> {
        protected getFormKey() { return StockAllocationItemsForm.formKey; }
        protected getLocalTextPrefix() { return StockAllocationItemsRow.localTextPrefix; }
        protected getDeletePermission() { return StockAllocationItemsRow.deletePermission; }
        protected getInsertPermission() { return StockAllocationItemsRow.insertPermission; }
        protected getUpdatePermission() { return StockAllocationItemsRow.updatePermission; }

        public form = new StockAllocationItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        Image: any;
        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public ItemMaster: any;
        public LotNo: any;

        // #endregion 

        // #region Constructor
        constructor() {
            super();
            $('s-StockAllocation-StockAllocationItemsDialog').attr('autocomplete', 'off');
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
           // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails); 
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorToolbar(this.form.AllocatedItems);
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);

            // #endregion
             
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }
        // #endregion

        // #region Open Dialog, Close Dialog etc

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as StockAllocationDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDiscount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.form.TransDate.valueAsDate
            //this.Setfields();

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            } 
        }

        getItem() {
            return this.getSaveEntity();
        }

        // #endregion
        setData(items: any[]) {
            this.form.AllocatedItems.setData(items);
        }
        
        validateBeforeSave() {
            super.validateBeforeSave();
            var allocateditems = this.form.AllocatedItems.getItems();
            var pcs = 0, wt = 0;
            for (var i = 0; i < allocateditems.length; i++) {
                pcs += allocateditems[i].Pieces;
                wt += allocateditems[i].Weight;
            }
            this.form.AllocatedPieces.value = pcs;
            this.form.AllocatedWeight.value = wt;
            return true;
        }
    
        // #endregion

    }
}